import { render } from "./SubmittedOffersCombined.vue?vue&type=template&id=022e7966&scoped=true"
import script from "./SubmittedOffersCombined.vue?vue&type=script&lang=js"
export * from "./SubmittedOffersCombined.vue?vue&type=script&lang=js"

import "./SubmittedOffersCombined.vue?vue&type=style&index=0&id=022e7966&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-022e7966"

export default script